import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3edfb713&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./assets/index.rem.css?vue&type=style&index=0&id=3edfb713&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3edfb713",
  null
  
)

export default component.exports